/**
 * Serviço para gerenciar a chave da API OpenAI
 * Armazena a chave no localStorage do navegador
 */

// Nome da chave no localStorage
const API_KEY_STORAGE_NAME = 'floratta_openai_api_key';

/**
 * Salva a chave da API no localStorage
 * @param {string} apiKey - A chave da API OpenAI
 */
export const saveApiKey = (apiKey) => {
  if (!apiKey) return false;
  
  try {
    // Criptografia simples para não armazenar a chave em texto puro
    // Não é uma criptografia forte, mas é melhor que nada para uso local
    const encodedKey = btoa(apiKey);
    localStorage.setItem(API_KEY_STORAGE_NAME, encodedKey);
    return true;
  } catch (error) {
    console.error('Erro ao salvar a chave da API:', error);
    return false;
  }
};

/**
 * Recupera a chave da API do localStorage
 * @returns {string|null} A chave da API ou null se não existir
 */
export const getApiKey = () => {
  try {
    const encodedKey = localStorage.getItem(API_KEY_STORAGE_NAME);
    if (!encodedKey) return null;
    
    // Decodifica a chave
    return atob(encodedKey);
  } catch (error) {
    console.error('Erro ao recuperar a chave da API:', error);
    return null;
  }
};

/**
 * Remove a chave da API do localStorage
 */
export const removeApiKey = () => {
  try {
    localStorage.removeItem(API_KEY_STORAGE_NAME);
    return true;
  } catch (error) {
    console.error('Erro ao remover a chave da API:', error);
    return false;
  }
};

/**
 * Verifica se existe uma chave da API salva
 * @returns {boolean} True se existir uma chave salva
 */
export const hasApiKey = () => {
  return !!getApiKey();
};
